import { render, staticRenderFns } from "./ProductCategoryFormScreen.vue?vue&type=template&id=0a4bcb55&"
import script from "./ProductCategoryFormScreen.vue?vue&type=script&lang=ts&"
export * from "./ProductCategoryFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports